// Disposable-mail providers, for 11d's finding panel.
//
// A short, deliberately conservative list. The panel only names the domain as
// disposable when it is ON this list — an unrecognised domain says nothing
// rather than accusing a real company of being throwaway mail, which is the
// kind of wrong that makes someone stop trusting the whole screen.
//
// The list is the cheap half of the finding. The number of OTHER records
// sharing the domain is the half that turns one dead record into a cleanup
// task, and that is counted from the register (see `countDomainSiblings`).
const DISPOSABLE = new Set([
  'yopmail.com',
  'mailinator.com',
  'guerrillamail.com',
  'guerrillamail.net',
  '10minutemail.com',
  'temp-mail.org',
  'tempmail.com',
  'throwawaymail.com',
  'trashmail.com',
  'sharklasers.com',
  'getnada.com',
  'maildrop.cc',
  'dispostable.com',
  'fakeinbox.com',
  'mailnesia.com',
  'mytemp.email',
  'moakt.com',
  'emailondeck.com',
]);

/** The part after the @, lower-cased. '' when the address has no domain. */
export function domainOf(email: string): string {
  return (email.split('@')[1] ?? '').trim().toLowerCase();
}

export function isDisposableDomain(domain: string): boolean {
  return DISPOSABLE.has(domain);
}
